import { createSelector } from 'reselect'

import { selectState } from './selectState'

export const selectProducts = createSelector([selectState], (state) => state.products)
